import type { CSSProperties } from 'react';
import type { AccentToken } from '../engine/types';

/** Map a mode's accent token onto the local --accent / --accent-wash variables. */
export function accentVars(accent: AccentToken): CSSProperties {
  return {
    '--accent': `var(--${accent})`,
    '--accent-wash': `var(--${accent}-wash)`,
  } as CSSProperties;
}
